import styled from "styled-components";
import {
  DialogTitle,
  DialogTitleActions,
} from "@ebscois/react-component-library";

export const StyledDialogTitle = styled(DialogTitle)`
  padding: 0.25rem 0.25rem 0 0;
  direction: rtl; /* Sticks the close button to the right end */
`;

export const StyledDialogTitleActions = styled(DialogTitleActions)`
  width: auto;
`;

export const StyledTableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  padding: ${({ theme }) => theme.space.xxl} ${({ theme }) => theme.space.lg};

  & .tablecap {
    color: ${({ theme }) => theme.colors.primary.base};
    font-size: ${({ theme }) => theme.font.size.lg};
    line-height: 2rem;
  }
  .table {
    margin-top: 0;
    width: auto;
    @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
      width: 100%;
      table-layout: auto;
    }
    & caption {
      margin-top: 0;
    }
  }
  .external-link-icon {
    height: 1.1rem;
    width: 1.1rem;
    margin: ${({ theme }) => theme.space.xs};
    margin-bottom: -${({ theme }) => theme.space.xs};
  }
  .link {
    color: ${({ theme }) => theme.colors.anchor};
  }
`;
